import type { Theme } from '@mui/material';

export const styles = {
  cellWithBar: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 300,
    width: '100%',
    height: '100%',
  },

  cellWithBarLabel: {
    width: '3.5em',
  },

  cellWithBarBarWrapper: (theme: Theme) => ({
    height: '100%',
    flexGrow: 1,
    paddingX: theme.spacing(1),
  }),

  cellWithBarBar: (percentage: number | null) => (theme: Theme) => ({
    backgroundColor: theme.colors.responseManagerBars,
    height: '100%',
    width: `${percentage}%`,
    transition: 'width 0.5s',
  }),
};
